import { useState } from 'react';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../../utils/Button';
import FocusControl from '../../../../utils/FocusControl';
import InputField from '../../../../utils/InputField';
import { ApiSubsEditBasicInfo } from '../SubscriptionsDetailsOpe';
import { useSubscriptionsDetails } from '../SubscriptionsDetailsProvider';

function ChangeBasicInfoModal({ closeModal, data }) {
    const { handleReload } = useSubscriptionsDetails();
    const { setMessage } = useTemplate();
    const [loading, setLoading] = useState(false);
    const [isError, setIsError] = useState('');

    const [formData, setFormData] = useState({
        SubscriptionName: data?.subscriptionName
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name) {
            setFormData((d) => ({ ...d, [name]: value }));
        }
    };

    const handleSaveClick = (ev) => {
        ev.preventDefault();
        setLoading(true);
        ApiSubsEditBasicInfo(data?.id, formData, setIsError)
            .then(({ title }) => {
                setMessage({ type: 'success', text: title });
                handleReload();
                closeModal();
            })
            .catch((err) => {
                setLoading(false);
                setMessage({ type: 'error', text: err.toString() });
            });
    };
    FocusControl(isError, setIsError, formData);
    return (
        <form onSubmit={handleSaveClick}>
            <div className="mb-4">
                <div className="flex flex-col gap-y-4">
                    <InputField
                        label="Subscription Name"
                        placeholder="Type subscription name..."
                        name="SubscriptionName"
                        formData={formData}
                        onChange={handleChange}
                        required
                    />
                </div>
            </div>
            <div className="flex justify-end">
                <div className="flex items-center gap-x-2">
                    <ButtonCancel title="Cancel" onClick={closeModal} />
                    <ButtonPrimary title="Save Change" btnType="submit" loading={loading} />
                </div>
            </div>
        </form>
    );
}

export default ChangeBasicInfoModal;
